import styles from './Mensagem.module.css'
 
import {CgAttachment} from 'react-icons/cg'
import {useCallback, useEffect, useState} from 'react'
import AnexoViewer from './AnexoViewer'
import Button from '../form/Button'
 
function Mensagem({msg}) {
 
    const [anexoSelecionado, setAnexoSelecionado] = useState(null)
    const [extensoes, setExtensoes] = useState({})
    const registrarExtensao = useCallback((anexoId, extensao) => {
        setExtensoes((atuais) => atuais[anexoId] === extensao ? atuais : {...atuais, [anexoId]: extensao})
    }, [])

    useEffect(() => {
        const controller = new AbortController()
        const extensoesPorTipo = {
            'application/pdf': 'PDF',
            'image/jpeg': 'JPG',
            'image/png': 'PNG',
            'image/gif': 'GIF',
            'image/webp': 'WEBP',
            'application/xml': 'XML',
            'text/xml': 'XML',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX'
        }

        msg.ANEXOS.forEach(async (anexo) => {
            const nome = anexo.TX_NOME || ''
            if (/\.[a-z0-9]+$/i.test(nome)) return
            try {
                const response = await fetch(`${msg.base_url.replace(/\/$/, '')}/${encodeURIComponent(nome)}`, {
                    method: 'HEAD',
                    signal: controller.signal
                })
                if (!response.ok) return
                const tipo = response.headers.get('Content-Type')?.split(';')[0].toLowerCase()
                const disposition = response.headers.get('Content-Disposition') || ''
                const nomeHeader = disposition.match(/filename\*?=(?:UTF-8''|["']?)([^"';]+)/i)?.[1] || ''
                const extensaoHeader = nomeHeader.match(/\.([a-z0-9]+)$/i)?.[1]
                const extensao = extensaoHeader || extensoesPorTipo[tipo]
                if (extensao) registrarExtensao(anexo.ID, extensao)
            } catch (_) {
                // A extensão ainda será detectada pelo conteúdo quando o anexo for aberto.
            }
        })

        return () => controller.abort()
    }, [msg.ANEXOS, msg.base_url, registrarExtensao])

    const extensaoDoAnexo = (anexo) => {
        const nome = anexo.TX_NOME || anexo.NOME_ORIGINAL || anexo.TX_NOME_ORIGINAL || ''
        const extensaoDoNome = nome.match(/\.([a-z0-9]+)(?:[?#].*)?$/i)?.[1]
        const extensaoDaApi = anexo.EXTENSAO || anexo.TX_EXTENSAO || anexo.TP_ARQUIVO
        return (extensoes[anexo.ID] || extensaoDoNome || extensaoDaApi || '').replace(/^\./, '').toUpperCase()
    }

    const isStaff = (msg.ATRIBUICAO || '').toUpperCase() !== 'AUTOR'

    return (
        <div className={`${styles.chamadoCommentContent} ${isStaff ? styles.staff : styles.autor}`}>
            <div className={styles.chamadoCommentPointer}>
                <div className={styles.chamadoCommentAuthor}>
                    {msg.ATRIBUICAO}: {msg.CD_USUARIO}
                </div>
                <div className={styles.chamadoCommentEmpresa}>
                    Empresa: {msg.TX_NOME_EMPRESA}
                </div>
                <div className={styles.chamadoCommentDate}>
                    Enviado em: {msg.DT_CRIACAO}
                </div>

            </div>
            <div className={styles.chamadoComment} dangerouslySetInnerHTML={{__html: msg.TX_CONTEUDO}}>

            </div>
            <div className={styles.chamadoCommentAttach}>
                {msg.ANEXOS.map((anexo) => {
                    const extensao = extensaoDoAnexo(anexo)
                    return <Button key={anexo.ID} handleOnClick={() => setAnexoSelecionado(anexo)} text={`Anexo ${anexo.ID}${extensao ? `.${extensao}` : ''}`} icon={<CgAttachment />} />
                })}
            </div>
            {anexoSelecionado && <AnexoViewer
                anexos={msg.ANEXOS}
                baseUrl={msg.base_url}
                selectedId={anexoSelecionado.ID}
                onTipoDetectado={registrarExtensao}
                onClose={() => setAnexoSelecionado(null)}
            />}
        </div>
    )

}

export default Mensagem
